const e="1rem",r="1.5rem",m="2rem";export{m as sizeIconLarge,r as sizeIconMedium,e as sizeIconSmall};
